import { render, staticRenderFns } from "./OCRModels.vue?vue&type=template&id=162afc78&scoped=true"
import script from "./OCRModels.vue?vue&type=script&lang=js"
export * from "./OCRModels.vue?vue&type=script&lang=js"
import style0 from "./OCRModels.vue?vue&type=style&index=0&id=162afc78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162afc78",
  null
  
)

export default component.exports